// Assumptions for the affordability / investor metrics, shared by the ingest (ingest/derived.ts) and the metrics
// computed per request (src/personal.ts, src/computed.ts). No imports, so anything can use it without a cycle.
// Percent values are fractions (0.2 = 20%).
export const ASSUMPTIONS = {
  downPayment: 0.2,
  termMonths: 360,
  affordableShare: 0.3, // payment <= 30% of gross income
  expenseRatio: 0.3, // share of rent lost to vacancy, repairs and management; insurance is subtracted separately (cap rate)
  expenseRatioNoInsurance: 0.35, // the same incl. insurance, where no premium estimate exists
  // California reassesses at purchase (Prop 13): 1% general levy + voter-approved debt, typically 0.1-0.3% more. A buyer
  // pays this, not the area's median tax over median value (long-time owners' bills, and ACS caps both at $10,000+ / $2M+)
  caPurchaseTaxRate: 0.0115,
  // income-based ratios are left out where ACS median income is top- / bottom-coded ($250,000+ / $2,500-) or the
  // area is too small for a median to mean much
  incomeMin: 2500,
  incomeMax: 250000,
  minPopulation: 500,
};

/** ACS top codes: a median at these values means "this or more". */
export const ACS_TOP = { income: 250001, propertyTax: 10001, homeValue: 2000001 };
